exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".links[data-v-774f65aa] {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));\n}\n.links .list-input[data-v-774f65aa], .links .no-content[data-v-774f65aa] {\n  grid-column: 1/-1;\n}", ""]);

// exports
